package com.appsyde.shared.app.presentation.ticket

import com.appsyde.shared.modules.ai.domain.model.AiExtractV2
import com.appsyde.shared.modules.ai.domain.model.DetectedFieldV2
import com.appsyde.shared.modules.ticket.domain.model.TicketHistoryItem
import com.appsyde.shared.modules.ticket.domain.model.TicketOriginalHistoryItem
import com.appsyde.shared.modules.ticket.domain.model.TicketRespondMessage
import com.appsyde.shared.modules.ticket.domain.model.TicketRespondState

// ---------------------------------------------------------------------
// Legacy UI states (history, send, transition)
// ---------------------------------------------------------------------

sealed class HistoryState {
    object Hidden : HistoryState()
    object Loading : HistoryState()
    data class Loaded(val items: List<TicketHistoryItem>) : HistoryState()
    data class Error(val message: String) : HistoryState()
}

sealed class OriginalHistoryState {
    object Hidden : OriginalHistoryState()
    object Loading : OriginalHistoryState()
    data class Loaded(val items: List<TicketOriginalHistoryItem>) : OriginalHistoryState()
    data class Error(val message: String) : OriginalHistoryState()
}

enum class TicketTransitionState {
    Idle, Exiting, Entering, BackExiting, BackEntering
}

sealed class SendState {
    object Idle : SendState()
    object Sending : SendState()
    object Success : SendState()
    data class Error(val message: String) : SendState()
}

// ---------------------------------------------------------------------
// V2 UI State (segment-first)
// ---------------------------------------------------------------------

sealed class TicketState {
    object Loading : TicketState()

    /** End of list: no more tickets to show, display InboxEmptyView. */
    data class Empty(val canGoBack: Boolean = false) : TicketState()

    data class Success(
        val respond: TicketRespondState,
        val pivotInboundMessageId: String?,
        val activeInbound: TicketRespondMessage?,
        val activeMessages: List<TicketRespondMessage>,
        val extract: AiExtractV2? = null,
        val missingKeys: List<String> = emptyList(),
        val toConfirmKeys: List<String> = emptyList(),
        val sidebarDetected: List<DetectedFieldV2> = emptyList(),
        val replyText: String = "",
        /** Réponse générée par le backend (draft IA) ; utilisée par le bouton « Réponse suggérée » sans régénérer. */
        val suggestedReplyText: String = "",
        val stableReplyText: String? = null,
        val isRegenerating: Boolean = false,
        val isModified: Boolean = false,
        val noMoreTickets: Boolean = false,
        val canGoBack: Boolean = false,
        val transition: TicketTransitionState = TicketTransitionState.Idle,
        val history: HistoryState = HistoryState.Hidden,
        val originalHistory: OriginalHistoryState = OriginalHistoryState.Hidden
    ) : TicketState()
}
